import { EMAIL_NOT_PROVIDED, EMAIL_NOT_VALID, EMAIL_PASSWORD_NOT_PROVIDED, PASSWORD_NOT_PROVIDED } from "../../../../constants/ErrorConstants";
import { FAILURE, SUCCESS } from "../../../../constants/BaseConstants";
import { call, put, select } from "redux-saga/effects";

import Error from "./../../../../helpers/Error";
import { GET_TOKEN } from "../../../../constants/ClientConstants";
import getEmailSelector from "../../../selectors/ClientSelectors/getEmailSelector";
import getPasswordSelector from "../../../selectors/ClientSelectors/getPasswordSelector";
import getTokenCall from "../../../../api/ClientCalls/getTokenCall";
import validateEmail from "../../../../helpers/validateEmail";

export default function* submitLoginSaga(): any {
    try {
        const email = yield select(getEmailSelector);
        const password = yield select(getPasswordSelector);

        if (email && password) {
            if (validateEmail(email)) {
                const user = yield call(getTokenCall, email, password);
                yield put({ type: GET_TOKEN + SUCCESS, user });
            } else {
                throw new Error(EMAIL_NOT_VALID);
            }
        } else if (!email && password) {
            throw new Error(EMAIL_NOT_PROVIDED);
        } else if (email && !password) {
            if (validateEmail(email)) {
                throw new Error(PASSWORD_NOT_PROVIDED);
            } else {
                throw new Error(EMAIL_NOT_VALID);
            }
        } else if (!email && !password) {
            throw new Error(EMAIL_PASSWORD_NOT_PROVIDED);
        }
    } catch (error) {
        yield put({ type: GET_TOKEN + FAILURE, error });
    }
}
